import { Component } from '@angular/core';

@Component({
    selector: 'app-section-divider',
    templateUrl: './section-divider.component.html',
    styleUrls: ['./section-divider.component.scss'],
    standalone: false
})
export class SectionDividerComponent {

}
